const lastname = [
    { type: 'required', message: 'Last name is required' },
    { type: 'minlength', message: 'Last name must be at least 3 characters long' },
    { type: 'maxlength', message: 'Last name cannot be more than 24 characters long' },
    { type: 'pattern', message: 'Your name must contain only numbers and letters' },
    // { type: 'validLastname', message: 'Your name has already been taken' },
    // { type: 'areEqual', message: 'You entered wrong username' },
]

export default { lastname };